"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOdsHardwareOrderOmsSchema = void 0;
exports.CreateOdsHardwareOrderOmsSchema = {
    $schema: 'http://json-schema.org/draft-07/schema#',
    properties: {
        orderNumber: {
            type: 'string',
            minLength: 3,
        },
        serialNumber: {
            type: 'string',
            minLength: 3,
        },
        contactId: {
            type: 'string',
            minLength: 1,
        },
    },
    anyOf: [
        {
            required: [
                'orderNumber',
            ],
        },
        {
            required: [
                'serialNumber',
            ],
        },
    ],
    type: 'object',
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLW9kcy1oYXJkd2FyZS1vcmRlci1vbXMtc2NoZW1hLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2RvbXMvc2NoZW1hcy9jcmVhdGUtb2RzLWhhcmR3YXJlLW9yZGVyLW9tcy1zY2hlbWEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQWEsUUFBQSwrQkFBK0IsR0FBRztJQUM3QyxPQUFPLEVBQUUseUNBQXlDO0lBQ2xELFVBQVUsRUFBRTtRQUNWLFdBQVcsRUFBRTtZQUNYLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELFlBQVksRUFBRTtZQUNaLElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtRQUNELFNBQVMsRUFBRTtZQUNULElBQUksRUFBRSxRQUFRO1lBQ2QsU0FBUyxFQUFFLENBQUM7U0FDYjtLQUNGO0lBQ0QsS0FBSyxFQUFFO1FBQ0w7WUFDRSxRQUFRLEVBQUU7Z0JBQ1IsYUFBYTthQUNkO1NBQ0Y7UUFDRDtZQUNFLFFBQVEsRUFBRTtnQkFDUixjQUFjO2FBQ2Y7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLFFBQVE7Q0FDZixDQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IENyZWF0ZU9kc0hhcmR3YXJlT3JkZXJPbXNTY2hlbWEgPSB7XG4gICRzY2hlbWE6ICdodHRwOi8vanNvbi1zY2hlbWEub3JnL2RyYWZ0LTA3L3NjaGVtYSMnLFxuICBwcm9wZXJ0aWVzOiB7XG4gICAgb3JkZXJOdW1iZXI6IHtcbiAgICAgIHR5cGU6ICdzdHJpbmcnLFxuICAgICAgbWluTGVuZ3RoOiAzLFxuICAgIH0sXG4gICAgc2VyaWFsTnVtYmVyOiB7XG4gICAgICB0eXBlOiAnc3RyaW5nJyxcbiAgICAgIG1pbkxlbmd0aDogMyxcbiAgICB9LFxuICAgIGNvbnRhY3RJZDoge1xuICAgICAgdHlwZTogJ3N0cmluZycsXG4gICAgICBtaW5MZW5ndGg6IDEsXG4gICAgfSxcbiAgfSxcbiAgYW55T2Y6IFtcbiAgICB7XG4gICAgICByZXF1aXJlZDogW1xuICAgICAgICAnb3JkZXJOdW1iZXInLFxuICAgICAgXSxcbiAgICB9LFxuICAgIHtcbiAgICAgIHJlcXVpcmVkOiBbXG4gICAgICAgICdzZXJpYWxOdW1iZXInLFxuICAgICAgXSxcbiAgICB9LFxuICBdLFxuICB0eXBlOiAnb2JqZWN0Jyxcbn1cbiJdfQ==